import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AnchorIcon(props: IconProps) {
    return <Icon {...props} iconKey={"anchor"}/>
}
